import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import E from '../ui_core/E';
export default class HouseGridSelectorInfo {
	constructor({getWindowElement, configuration, showBrochureGenerationDialog}){
		this._getWindowElement= getWindowElement;
		this._configuration = configuration;
		this.load= this.load.bind(this);
		this._getHandleIframeMessage = this._getHandleIframeMessage.bind(this);
		this.resized = this.resized.bind(this);
		this._element = E.div('house-grid-selector-info');
		this._imageWrapperElement = E.div("image-wrapper");
		this._img = E.img('image');
		this._element.appendChild(this._imageWrapperElement);
		this._imageWrapperElement.appendChild(this._img);
		this._otherInfoElement = E.div('other-info');
		this._element.appendChild(this._otherInfoElement);
		this._nameElement = E.div('name');
		this._otherInfoElement.appendChild(this._nameElement);
		this._descriptionElement = E.div('description');
		this._otherInfoElement.appendChild(this._descriptionElement);
		this._offersElement = E.div('offers');
		this._otherInfoElement.appendChild(this._offersElement);
		this._currentFeatures =[];
		this._featuresElement = E.div('features');
		this._otherInfoElement.appendChild(this._featuresElement);
		this._galleryIframe = document.createElement('iframe');
		this._galleryIframe.classList.add('gallery');
		this._galleryIframe.allow="fullscreen";
		
		this._floorPlansIframe = document.createElement('iframe');
		this._floorPlansIframe.classList.add('floor-plans');
		this._floorPlansIframe.allow="fullscreen";
		
		this._chooseYourStyleIframe = document.createElement('iframe');
		this._chooseYourStyleIframe.classList.add('choose-your-style');
		this._chooseYourStyleIframe.allow="fullscreen";
		
		this._configureYourHomeIframe = document.createElement('iframe');
		this._configureYourHomeIframe.classList.add('configure-your-home');
		this._configureYourHomeIframe.allow="fullscreen";
		
		this._otherInfoEntries = [
			{iframe:this._galleryIframe, getUrl:(houseType)=>houseType.galleryUrl, autoHeight:true},
			{ iframe:this._floorPlansIframe, getUrl:(houseType)=>houseType.floorPlansIframeUrl, autoHeight:true},
			{title:'', iframe:this._chooseYourStyleIframe,  getUrl:(houseType)=>{
				if(houseType.chooseYourStyleIframeUrl)
					return houseType.chooseYourStyleIframeUrl;
				return houseType.chooseYourStyleVideoUrl;
			}, autoHeight:true},
			{title:'', iframe:this._configureYourHomeIframe,
			getUrl:(houseType)=>{
				if(houseType.configuratorUrl)
					return houseType.configuratorUrl;
				if(houseType.tourUrl)
					return houseType.tourUrl;
				return houseType.videoUrl;
			}, autoHeight:true}
		];
		this._otherInfoEntries.forEach((e)=>{
			const {title, iframe, autoHeight}=e;
			const entryElement = E.div('entry');
			if(title){
				const titleElement = E.div('title');
				titleElement.textContent = title;
				entryElement.appendChild(titleElement);
			}
			entryElement.appendChild(iframe);
			this._otherInfoElement.appendChild(entryElement);
			e.entryElement = entryElement;
			if(autoHeight){
				const handleMessage = this._getHandleIframeMessage(iframe);
				window.addEventListener('message', handleMessage);
				iframe.frameborder="0";
				iframe.scrolling="no";
			}
		});
		if(configuration.brochureGeneratorUrl){
			const buttonSendBrochure = document.createElement('button');
			buttonSendBrochure.classList.add("button-send-brochure");
			buttonSendBrochure.addEventListener('click', ()=>showBrochureGenerationDialog({plot:this._firstPlot}));
			buttonSendBrochure.innerHTML = 'Send Brochure';
			this._otherInfoElement.appendChild(buttonSendBrochure);
		}
	}
	get element(){
		return this._element;
	}
	load(houseType){
		const firstPlot = houseType.plots[0];
		this._firstPlot = firstPlot;
		const firstUnit = firstPlot.unit;
		this._img.src = 'about:blank';
		this._img.src = `${Urls.getAssetsForSite(this._configuration.siteSlug)}${UrlHelper.removeStartSlash(firstUnit.frontViewImage.getBestEntryToFitHeight(4000).relativePath)}`;
		this._nameElement.textContent = houseType.name;
		this._descriptionElement.textContent = houseType.about;
		if(houseType.offers){
			this._offersElement.textContent = houseType.offers;
			this._offersElement.classList.add('visible');
		}
		else{
			this._offersElement.textContent ='';
			this._offersElement.classList.remove('visible');
		}
		this._currentFeatures.forEach(f=>this._featuresElement.removeChild(f));
		this._currentFeatures =[];
		if(houseType.features){
			houseType.features.forEach(f=>{
				const featureElement = E.div('feature');
				featureElement.textContent = `- ${f}`;
				this._currentFeatures.push(featureElement);
				this._featuresElement.appendChild(featureElement);
			});
		}
		this._otherInfoEntries.forEach(({getUrl, entryElement, iframe})=>{
			const url = getUrl(houseType);
			if(url){
				entryElement.style.display = 'block';
				iframe.src=url;
			}
			else{
				entryElement.style.display = 'none';
			}
		});
		setTimeout(this.resized, 0);
	}
	resized(){
		const iframeHeight = this._getWindowElement().clientHeight;
		this._chooseYourStyleIframe.style.height =iframeHeight +'px';
		this._configureYourHomeIframe.style.height = iframeHeight+'px';
	}
	_getHandleIframeMessage(iframe){
		return (message)=>{
			if (message.source !== iframe.contentWindow)
				return;
			const {data}=message;
			iframe.style.height = `${data.height}px`;
		};
	}
}
